<template>
  <b-container>
    <b-row class="mt-3">
			<b-col cols="2"></b-col>
			<b-col cols="8" class="text-center"><b-img src="http://api.checkpoint.recco.com.br/image_recco/recco.png" fluid style="width:100%; max-width:300px;"/></b-col>
			<b-col cols="2"></b-col>
    </b-row>
    <b-row>
      <b-col cols="1"></b-col>
      <b-col cols="10">
        <div class="card text-white mt-4" style="background:#D30556;">
          <div class="card-header">CheckPoint</div>
          <div class="card-body">
            <b-form @submit="onSubmit">
              <b-form-group>
                <b-form-input type="email" v-model="email" required placeholder="E-mail"></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input type="password" v-model="password" required placeholder="Senha"></b-form-input>
                <div class="text-sm-right">
                    <b-link href="#" @click="redefinirSenha()">Redefinir Senha.</b-link>
                </div>
              </b-form-group>
              <b-button type="submit" style="background:#870337; border:none;">Entrar</b-button>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col cols="1"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'

export default {
  data () {
    return { email: '', password: '' }
  },
  created: function() {
    // Verifica se existe o item token no localStorage.
    if (localStorage.getItem('token')) this.$router.push('home');
  },
  methods: {
    onSubmit (event) {
      // Não permite o envio do formulário.
      event.preventDefault();

      // Requisição ao webservice.
      http.post('/login', { email: this.email, password: this.password })
      .then(response => {
        // Armazenando o token no localStorage.
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('level', response.data.level)
        localStorage.setItem('admin', response.data.admin)
        localStorage.setItem('stores', JSON.stringify(response.data.stores))
        localStorage.setItem('nm_user', response.data.nm_user)
        localStorage.setItem('user', response.data.user)
        localStorage.setItem('global-store', 'all')

        // Definindo o token no headers do axios.
        http.defaults.headers.common['Authorization'] = response.data.token

        // Redirecionado para a home.
        this.$router.push('home')
      })
      .catch(error => {
        swal({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        })
      })
    },
    redefinirSenha (evt) {

      if(this.email != ""){
        http.post('/user/request', { email: this.email})
          .then(response => {
            swal({
              icon: 'success',
              title: 'Ok!',
              text: response.data.mensagem
            })
          })
          .catch(error => {
            swal({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            })
          })
      } else {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Preencha o campo E-mail.'
        })
      }
    }
  }
}
</script>

<style scoped>
input, button { font-family:'Roboto', sans-serif; }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue